<div class="article mb-3 mt-4" [ngClass]="article.fromCustomer ? 'customer' : 'system'">
  @if (article.fromCustomer) {
    <app-avatar class="d-none d-md-block avatar" [name]='article.from' [round]="true"
    [textSizeRatio]="2.5" [size]="40"></app-avatar>
  }
  @if (article.fromCustomer) {
    <app-avatar class="d-block d-md-none avatar" [name]='article.from' [round]="true"
    [textSizeRatio]="2" [size]="30"></app-avatar>
  }
  <span class="arrow"></span>
  <div class="d-none d-md-flex justify-content-between cursor-pointer p-3" (click)="toggle()">
    <h2>{{ article.from }}</h2>
    <div class="text-light-grey">
      <span class="me-3">{{ article.time | date:'le dd/MM/yyyy à HH\'h\'mm' }}</span>
      <fa-icon size='lg' [icon]="reduced ? 'angle-down' : 'angle-up'"></fa-icon>
    </div>
  </div>
  <div class="d-flex justify-content-between d-md-none ps-3 pt-md-3 pe-3 pb-0">
    <h2 class="d-none d-md-block">{{ article.from }}</h2>
    @if (article.from.split('<'); as splitted) {
      <div class="d-block d-md-none mobile-title">
        <h2>{{ splitted[0] }}</h2>
        @if (splitted.length > 1) {
          <span>{{ splitted[1].split('>')[0] }}</span>
        } @else {
          <span>
            <br/>
          </span>
        }
      </div>
    }
    <span class="bottom-date text-light-grey">{{ article.time | date:'le dd/MM/yyyy à HH\'h\'mm' }}</span>
  </div>
  <div [(ngbCollapse)]="reduced">
    <div class="pt-0 pe-3 ps-3 pb-2rem pb-md-3">
      @if (article.cc.length > 0) {
        <div class="text-light-grey pb-2">Copie à : {{ article.cc.join('; ') }}</div>
      }

      <div class="pt-md-3 pt-2 text-break article-content" [innerHTML]="htmlContent"></div>
      @if (article.attachments.length > 0) {
        <div class="separator">
          @for (att of article.attachments; track att) {
            <app-attachment-downloader [attachment]="att"
            [ticketId]="ticketId"></app-attachment-downloader>
          }
        </div>
      }
    </div>
  </div>
</div>
